import { httpClient } from '../httpClient';

export function sendCardToEmail(cardId: string, email: string) {
  return httpClient.post(
    `/artifacts/certificates/${cardId}/pdf/emails`,
    JSON.stringify(email),
    { headers: { 'Content-Type': 'application/json' } },
  );
}
